import type { TSliceReducer } from 'core/store';
import { INavigationState } from './types';

const updateNavigationPage: TSliceReducer<INavigationState, number | undefined> = (state, action) => {
  state.navigationList.pagination.currentPage = action.payload ?? 1;
};

const clearNavigationForm: TSliceReducer<INavigationState> = state => {
  state.form.errors = {};
  state.form.loading = false;
  state.form.success = false;
};

export const reducers = { updateNavigationPage, clearNavigationForm };
